<form [formGroup]="specInkomenBox2FormGroup">
    <div class="row">
        <div formGroupName="specificatieBox2">
            <div formGroupName="opbouw">
                <div class="row">
                    <div class="col-7">
                        Reguliere voordelen
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="reguliereVoordelen"
                                id="reguliereVoordelen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                </div>
                <div class="row">
                    <div class="col-7">
                        Af: Aftrekbare kosten
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="aftrekbareKosten"
                                id="aftrekbareKosten"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                </div>

                <div class="row">
                    <div class="col-7">
                        Fictieve reguliere voordelen
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="fictieveReguliereVoordelen"
                                id="fictieveReguliereVoordelen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                </div>

                <div class="row">
                    <div class="col-7">
                        Vervreemdingsvoordelen
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="vervreemdingsVoordelen"
                                id="vervreemdingsVoordelen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                </div>

                <div class="row">
                    <div class="col-7">
                        Af: Verkrijgingsprijs
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="verkrijgingsPrijs"
                                id="verkrijgingsPrijs"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                </div>

            </div>
        </div>
    </div>
</form>
<form [formGroup]="specInkomenBox2FormGroup">
    <div formGroupName="specificatieInkomenBox2">
        <div formGroupName="opbouw">
            <div class="row">
                <div class="col-7">
                    <p><b>Inkomen uit aanmerkelijk belang</b></p>
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="saldoAanmerkelijkBelang"
                            id="saldoAanmerkelijkBelang"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
            </div>
        </div>
    </div>
</form>
